var map = {
	"./charts.png": 4700,
	"./chartsb.png": 1348,
	"./davidpic.png": 8837,
	"./diferencia.png": 9757,
	"./first.png": 5189,
	"./gpt.png": 2652,
	"./htmltag.png": 5926,
	"./htmltagb.png": 3910,
	"./meeting.png": 3548,
	"./mega.png": 6957,
	"./megab.png": 5291,
	"./pfp.PNG": 6120,
	"./section1bg.jpg": 9636,
	"./servicebackground.png": 770,
	"./stefpic.jpeg": 1840,
	"./testingAnime.gif": 2784,
	"./voilaLogo.jpeg": 1018,
	"./voilaLogoLetras.png": 5086,
	"./voilaLogoLetrasPurple.png": 228,
	"./voilalogomin.png": 1825,
	"./voilalogominwhite.png": 2282,
	"./whatsapp.png": 8461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9583;